export const BRAND = {
  name: "GREINCH WW LLC",
  shortName: "GREINCH",
  tagline: "You ask, we develop.",
  // Transparent-background processed logo (full-color brand on dark)
  logoUrl: "/greinch-logo.png",
  // Light recolored variant (cream G + coral GREINCH) for dark backgrounds where contrast is needed
  logoLightUrl: "/greinch-logo-light.png",
  email: "hello@greinchww.com",
  contactPhone: "+1 (307) 000-0000",
  address: "2106 House Ave, Suite 741",
  addressLine2: "Cheyenne, Wyoming, 82001 USA",
  socials: {
    linkedin: "#",
    twitter: "#",
    github: "#",
  },
};

export const NAV_LINKS = [
  { label: "Services", href: "#services", testid: "header-nav-services-link" },
  { label: "Industries", href: "#industries", testid: "header-nav-industries-link" },
  { label: "Process", href: "#process", testid: "header-nav-process-link" },
  { label: "Why us", href: "#why", testid: "header-nav-why-link" },
  { label: "Contact", href: "#contact", testid: "header-nav-contact-link" },
];
